export const ALLOWED_POSTAL_PREFIXES = [56, 57, 58, 59, 67, 68, 69];

export const ALLOWED_STATES = ["Karnataka", "Kerala"];

// Top-level city names to skip when resolving sublocality from geocoding results
export const SKIP_CITY_NAMES = ["Bengaluru", "Bangalore"];

export const LOCATION_UNAVAILABLE_MESSAGE = "This location isn't supported yet. Please select a location in Karnataka or Kerala.";

export const LOCATION_UNAVAILABLE_MESSAGE_LOCALES: Record<string, string> = {
	"en-IN": "This location isn't supported yet. Please select a location in Karnataka or Kerala.",
	"ar-AE": "هذا الموقع غير مدعوم حتى الآن. يرجى اختيار موقع في كارناتاكا أو كيرالا.",
	"kn-IN": "ಈ ಸ್ಥಳವು ಇನ್ನೂ ಬೆಂಬಲಿತವಾಗಿಲ್ಲ. ದಯವಿಟ್ಟು ಕರ್ನಾಟಕ ಅಥವಾ ಕೇರಳದಲ್ಲಿ ಸ್ಥಳವನ್ನು ಆಯ್ಕೆಮಾಡಿ.",
};
